import { Box, FormControl, MenuItem, Select } from '@material-ui/core';
import { getCreditCardDetailsById, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useParticipantSourceStyles } from '@/components/widgets/ParticipantSourceWidget/_shared/hooks/useParticipantSourceStyles';
import { findCreditCardOnboardingDetailsByRole } from '@/components/widgets/ParticipantSourceWidget/_shared/utils/findCreditCardOnboardingDetailsByRole';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';

export const CreditCardParticipantSourceWidget = () => {
  const { creditCardId } = useParams();
  if (!creditCardId) return null;

  const { data: creditCardDetails, loading: loadingDetails } = useCache(getCreditCardDetailsById, { id: creditCardId });

  const disabled = !creditCardDetails?.coBorrower;

  const {
    state: { applicationParticipant, loading },
    actions: pageActions,
  } = usePageContext();

  const { classes } = useParticipantSourceStyles({ disabled: !!disabled, loading: loadingDetails || loading });

  const onboardingDetails = [
    ...(creditCardDetails?.borrower?.onboardingDetails
      ? [{ ...creditCardDetails?.borrower?.onboardingDetails, role: OnboardingDetailsRole.BORROWER }]
      : []),
    ...(creditCardDetails?.coBorrower
      ? [{ ...creditCardDetails?.coBorrower?.onboardingDetails, role: OnboardingDetailsRole.CO_BORROWER }]
      : []),
  ];

  useEffect(() => {
    if (creditCardDetails && onboardingDetails) {
      const currentBorrowerOnboardingDetails = onboardingDetails.find(
        (details) => details.role === OnboardingDetailsRole.BORROWER,
      );
      pageActions.setApplicationParticipant({
        role: OnboardingDetailsRole.BORROWER,
        onboardingDetails: currentBorrowerOnboardingDetails,
      });
      return () => {
        pageActions.setApplicationParticipant({
          role: OnboardingDetailsRole.BORROWER,
          onboardingDetails: currentBorrowerOnboardingDetails,
        });
      };
    }
  }, [creditCardDetails]);

  const handleChange = (e) => {
    if (!creditCardDetails) return;

    const currentParticipant = findCreditCardOnboardingDetailsByRole({
      creditCard: creditCardDetails,
      role: applicationParticipant.role,
    });

    if (!currentParticipant) return;

    pageActions.setApplicationParticipant({
      role: e.target.value as OnboardingDetailsRole,
      onboardingDetails: { ...currentParticipant.onboardingDetails, role: e.target.value as OnboardingDetailsRole },
    });
  };

  return applicationParticipant.onboardingDetails ? (
    <div>
      <FormControl className={classes.root} variant="filled" style={{ width: '208px' }}>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={applicationParticipant.onboardingDetails.role}
          onChange={handleChange}
          disabled={disabled}
        >
          {onboardingDetails?.map((details) => {
            return (
              <MenuItem value={details.role} key={details.role}>
                {
                  <Box display={'flex'} flexDirection={'column'}>
                    <Font variant={'overline'} color={'title'}>
                      <Text tId={details.role} />
                    </Font>
                    <Font variant={'h5'} color={'title'}>
                      {`${details?.invitation?.fullName.firstName} ${details?.invitation?.fullName.lastName}`}
                    </Font>
                  </Box>
                }
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  ) : (
    <></>
  );
};
